const forge = require('node-forge');

export function RsaEncrypt(pem: string, payload: any) {
    const pubKey = forge.pki.publicKeyFromPem(pem);
    const encryptText = pubKey.encrypt(forge.util.encodeUtf8(JSON.stringify(payload)));
    return forge.util.encode64(encryptText);
}
